import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EmailsSharedEffects } from './+store/data/effects';
import { EMAILS_SHARED } from './+store/data/reducer';
import { reducers } from './+store/reducer';

@NgModule({
  imports: [StoreModule.forFeature(EMAILS_SHARED, reducers), EffectsModule.forFeature([EmailsSharedEffects])],
  providers: []
})
export class EmailsSharedModule {}
